import styled from 'styled-components';
import Card from '../../../../Card';
import CopyField from '../../../../CopyField';
import {typographyStyles} from '../../../../../utils/styles';

const StyledInvoiceRetrieval = styled(Card)`
  .ant-card-body {
    h3 {
      ${typographyStyles.heading.h5};
      svg {
        height: 20px;
        width: 20px;
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
    }
    & > p {
      color: ${props => props.theme.colors.neutral_7};
    }

    & > .ant-space {
      &:first-child {
        margin-bottom: 24px;
      }
    }
  }
  .ant-card-head {
    padding: 0 24px;
    flex-direction: unset;
  }
`;

const StyledInvoiceRetrievalCopyField = styled(CopyField)`
  align-items: end;
  padding: 0;

  & > div {
    width: 100%;
  }

  button {
    margin-left: 8px;
  }

  label {
    ${typographyStyles.body.medium};
    color: ${props => props.theme.colors.neutral_10};
    margin-bottom: 8px;
  }

  label + div {
    ${typographyStyles.body.regular};
    background-color: ${props => props.theme.colors.neutral_2};
    border-radius: 4px;
    padding: 5px 6px;
  }
`;

export {
  StyledInvoiceRetrieval,
  StyledInvoiceRetrievalCopyField
};
